import { FC } from 'react';

import MyProjectsSearchNotFound from '../MyProjectsSearch/MyProjectsSearchNotFound';
import ProjectFolderTreeModalProvider from '../ProjectPlayerBlock/ProjectFolderTreeModalProvider';

import Errors from './components/Errors';
import { MasonryVideoFoldersMemorized, MasonryVideoFoldersProps } from './components/MasonryVideoFolders';
import Notifications from './components/Notifications';
import useFetchFolder from './hooks/useFetchFolder';
import useMyProjectsEmptyList from './hooks/useMyProjectsEmptyList';
import useNavigationParams from './hooks/useNavigationParams';
import useNotFolderFound from './hooks/useNotFolderFound';
import useProjectDraftStatusUpdate from './hooks/useProjectDraftStatusUpdate';
import useReFreshOnWorkspaceChanged from './hooks/useReFreshOnWorkspaceChanged';
import useVideoFoldersLoader from './hooks/useVideoFoldersLoader';

const VideoFolders: FC<MasonryVideoFoldersProps> = props => {
  const [isLoader, Loader] = useVideoFoldersLoader();
  const [isError, NotFolderFound] = useNotFolderFound();
  const [isEmpty] = useMyProjectsEmptyList();

  const canShowVideoFolders = !isLoader && !isError && !isEmpty;

  useFetchFolder();
  useReFreshOnWorkspaceChanged();
  useNavigationParams();
  useProjectDraftStatusUpdate();

  return (
    <>
      <Errors />
      <Notifications />
      <NotFolderFound />
      <MyProjectsSearchNotFound />

      <ProjectFolderTreeModalProvider>
        {canShowVideoFolders ? <MasonryVideoFoldersMemorized {...props} /> : <Loader />}
      </ProjectFolderTreeModalProvider>
    </>
  );
};

export default VideoFolders;
